module.exports = __webpack_public_path__ + "img/tourism.2af172e8.png";